import dynamic from 'next/dynamic'

import { WrapperTokensFlowProvider } from '@/components/base/WrappedTokensFlow/context'
import { SwapProvider } from '@/components/home/context'
import SwapOrderbookProvider from '@/components/home/context.orderbook'
import { MainLayout } from '@/layouts/MainLayout'
import gssp from '@/utils/gssp'

const Home = dynamic(() => import('@/components/home'), { ssr: false })

const Index = () => {
  return (
    <MainLayout hasNautilus={true}>
      <SwapProvider>
        <SwapOrderbookProvider>
          <WrapperTokensFlowProvider>
            <Home />
          </WrapperTokensFlowProvider>
        </SwapOrderbookProvider>
      </SwapProvider>
    </MainLayout>
  )
}

export default Index

export const getServerSideProps = gssp()
